export type AuthContextType = {
    refreshToken?: string;
    accessToken?: string;
};
export const initialState: AuthContextType = {};
